module.exports = __webpack_public_path__ + "img/d_00019__.71300ce8.jpg";